"use strict";

(function () {
  jQuery(document).ready(function () {
    $(document).on("scroll", function () {
      if ($(document).scrollTop() > 100) {
        $("header").addClass("shrink");
        $("body").addClass("scrolled");
      } else {
        $("header").removeClass("shrink");
        $("body").removeClass("scrolled");
      }
    });

    //Hamburger menu slide in-out
    $(".navigation__openMenu").click(function () {
      $("body").toggleClass("menuOpened");
    });

    $(".navigation__overlay").click(function () {
      $("body").removeClass("menuOpened");
    });
    $(".close").click(function () {
      $("body").removeClass("menuOpened");
    });

    //Hamburger menu search actions
    $(".search-cancel").css("display", "none");

    $(".input-search").on("focusout", function (e) {
      $(".search-cancel").css("display", "none");

      if ($(".input-search").val() !== "") {
        $(".input-search").val("");
      }
    });

    $(".input-search").on("focusin", function (e) {
      $(".search-cancel").css("display", "inline");
    });

    // Login/Signup modal
    $(".btn-menu-modal").on("click", function () {
      if ($(this).hasClass("login-tab")) {
        showLogin();
      } else {
        showSignUp();
      }
      $("div.modal-window.login-signup").fadeIn().addClass("modal-open");
    });

    $(".close-tab").on("click", function () {
      $("div.modal-window.login-signup").removeClass("modal-open").fadeOut();
    });

    $("div.modal-container div.tabs ul.tabs-nav li a").on(
      "click",
      function (event) {
        event.preventDefault();
        if ($(this).hasClass("signup-tab")) {
          showSignUp();
        } else if ($(this).hasClass("login-tab")) {
          showLogin();
        }
      }
    );

    $("div.modal-container .tabs-stage .login-tab").hide();

    const showSignUp = () => {
      $("#login-tab").hide();
      $("#signup-tab").show();

      $(".tabs-nav li").removeClass("tab-active");
      $(".tabs-nav li a.signup-tab").parent().addClass("tab-active");
    };

    const showLogin = () => {
      $("#signup-tab").hide();
      $("#login-tab").show();

      $(".tabs-nav li").removeClass("tab-active");
      $(".tabs-nav li a.login-tab").parent().addClass("tab-active");
    };
    //endregion

    $(document).click(function (e) {
      if ($(e.target).is(".modal-window")) {
        $(".modal-window").fadeOut(500);
      }
    });

    $("select").niceSelect();
    $(".account-mobile-navigation select").change(function () {
      var getValue = $(this).val();
      if (getValue === "account") {
        document.location.href = "/account";
      } else if (getValue === "order") {
        document.location.href = "/pages/order-history";
      } else if (getValue === "sign-out") {
        document.location.href = "/account/logout";
      }
    });

    //PRODUCT-ACCORDION
    $(".accordion-content").slideUp();
    $(".accordion-title").removeClass("open");
    $(".accordion-title").on("click", function () {
      if ($(this).hasClass("open")) {
        $(this).siblings(".accordion-content").slideUp();
        $(this).removeClass("open");
      } else {
        $(".accordion-content").slideUp();
        $(".accordion-title").removeClass("open");
        $(this).siblings(".accordion-content").slideToggle();
        $(this).toggleClass("open");
      }
    });

    //FAQ-ACCORDION
    $(".faq_accordion-content").slideUp();
    $(".faq_accordion-head").removeClass("active");
    $(".faq_accordion-head").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).siblings(".faq_accordion-content").slideUp();
        $(this).removeClass("active");
      } else {
        $(".faq_accordion-content").slideUp();
        $(".faq_accordion-head").removeClass("active");
        $(this).siblings(".faq_accordion-content").slideToggle();
        $(this).toggleClass("active");
      }
    });

    //READ MORE/LESS BUTTON
    $(".readmore").click(function () {
      $(this).parent().find("p.moretext").slideToggle();
      $(this).removeClass("d-block").addClass("d-none").fadeOut();
      $(this)
        .parent()
        .find(".readless")
        .removeClass("d-none")
        .addClass("d-block")
        .fadeIn();
    });

    $(".readless").click(function () {
      $(this).parent().find("p.moretext").slideToggle();
      $(this).fadeOut().removeClass("d-block").addClass("d-none");
      $(this)
        .parent()
        .find(".readmore")
        .removeClass("d-none")
        .addClass("d-block")
        .fadeIn();
    });
  });

  //MODALS
  var modal = "";
  $(".btn-modal").on("click", function () {
    var modalId = $(this).data("modal-id");
    modal = modalId;
    $("[data-id=" + modalId + "]")
      .fadeIn()
      .addClass("modal-open");
    $("body").addClass("modal-isopen");
  });

  $(".close").on("click", function () {
    $(".modal-open").removeClass("modal-open").fadeOut();
    $("body").removeClass("modal-isopen");
  });

  $(document).click(function (e) {
    if ($(e.target).is(".modal-window")) {
      $("body").removeClass("modal-isopen");
      $(".modal-window").fadeOut(500);
    }
  });

  //TIMELINE timeline-accordion
  $(".timeline-accordion:nth-child(1) .timeline-accordion-head").addClass(
    "active"
  );
  $(".timeline-accordion:nth-child(1) .timeline-accordion-content").slideDown();
  $(".timeline-accordion-head").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).siblings(".timeline-accordion-content").slideUp();
      $(this).removeClass("active");
    } else {
      $(".timeline-accordion-content").slideUp();
      $(".timeline-accordion-head").removeClass("active");
      $(this).siblings(".timeline-accordion-content").slideToggle();
      $(this).toggleClass("active");
    }
  });

  //COLLECTION SLIDER
  const swiperCollection = new Swiper(".collection", {
    watchSlidesProgress: true,
    mousewheelReleaseOnEdges: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1.37,
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
      },
      768: {
        slidesPerView: 2.37,
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
      },
      1200: {
        slidesPerView: 2.8,
        spaceBetween: 24,
        slidesOffsetBefore: 84,
        slidesOffsetAfter: 24,
      },
      1440: {
        slidesPerView: 3.3,
        spaceBetween: 24,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 100,
      },
    },
  });

  //PRESS SLIDER
  var swiper = new Swiper(".press", {
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.36,
        spaceBetween: 24,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
      },
      768: {
        slidesPerView: 2.36,
        spaceBetween: 24,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
      },
      1100: {
        slidesPerView: 3.38,
        spaceBetween: 24,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 44,
      },
      1200: {
        slidesPerView: 4.38,
        spaceBetween: 24,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 114,
      },
      1440: {
        slidesPerView: 4.38,
        spaceBetween: 24,
        slidesOffsetAfter: 100,
      },
      1500: {
        slidesPerView: 5.38,
        spaceBetween: 24,
        slidesOffsetAfter: 170,
      },
    },
    speed: 500,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    on: {
      init: function init() {
        $(".swiper-progress-bar").removeClass("animate");
        $(".swiper-progress-bar").removeClass("active");
        $(".swiper-progress-bar").eq(0).addClass("animate");
        $(".swiper-progress-bar").eq(0).addClass("active");
      },
      slideChangeTransitionStart: function slideChangeTransitionStart() {
        $(".swiper-progress-bar").removeClass("animate");
        $(".swiper-progress-bar").removeClass("active");
        $(".swiper-progress-bar").eq(0).addClass("active");
      },
      slideChangeTransitionEnd: function slideChangeTransitionEnd() {
        $(".swiper-progress-bar").eq(0).addClass("animate");
      },
    },
  });
  $(".swiper-container").hover(
    function () {
      swiper.autoplay.stop();
      $(".swiper-progress-bar").removeClass("animate");
    },
    function () {
      swiper.autoplay.start();
      $(".swiper-progress-bar").addClass("animate");
    }
  );

  //INSTAGRAM SLIDER
  var swiper = new Swiper(".instagram", {
    breakpoints: {
      320: {
        slidesPerView: 2,
        grid: {
          rows: 2,
        },
      },
      1024: {
        slidesPerView: 5,
        grid: {
          rows: 1,
        },
      },
    },
  });

  //QTY INPUT
  var QtyInput = (function () {
    var $qtyInputs = $(".qty-input");
    if (!$qtyInputs.length) {
      return;
    }
    var $inputs = $qtyInputs.find(".product-qty");
    var $countBtn = $qtyInputs.find(".qty-count");
    var qtyMin = parseInt($inputs.attr("min"));
    var qtyMax = parseInt($inputs.attr("max"));

    $inputs.change(function () {
      var $this = $(this);
      var $minusBtn = $this.siblings(".qty-count--minus");
      var $addBtn = $this.siblings(".qty-count--add");
      var qty = parseInt($this.val());

      if (isNaN(qty) || qty <= qtyMin) {
        $this.val(qtyMin);
        $minusBtn.attr("disabled", true);
      } else {
        $minusBtn.attr("disabled", false);

        if (qty >= qtyMax) {
          $this.val(qtyMax);
          $addBtn.attr("disabled", true);
        } else {
          $this.val(qty);
          $addBtn.attr("disabled", false);
        }
      }
    });

    $countBtn.click(function () {
      var operator = this.dataset.action;
      var $this = $(this);
      var $input = $this.siblings(".product-qty");
      var qty = parseInt($input.val());

      if (operator == "add") {
        qty += 1;
        if (qty >= qtyMin + 1) {
          $this.siblings(".qty-count--minus").attr("disabled", false);
        }

        if (qty >= qtyMax) {
          $this.attr("disabled", true);
        }
      } else {
        qty = qty <= qtyMin ? qtyMin : (qty -= 1);

        if (qty == qtyMin) {
          $this.attr("disabled", true);
        }

        if (qty < qtyMax) {
          $this.siblings(".qty-count--add").attr("disabled", false);
        }
      }

      $input.val(qty);

      $("#update-cart").trigger("click");
    });
  })();

  function MobileOnlySlider() {
    let featuredSwiper;
    const sliderBreakpoint = window.matchMedia("(min-width:1025px)");
    const sliderBreakpointChecker = function () {
      if (sliderBreakpoint.matches === true) {
        $(".featured-slider > div")
          .removeClass("swiper-wrapper")
          .addClass("row");
        $(".featured-slider .row > div").removeClass("swiper-slide");

        if (featuredSwiper !== undefined) featuredSwiper.destroy(true, true);
      } else if (sliderBreakpoint.matches === false) {
        $(".featured-slider > div")
          .removeClass("row")
          .addClass("swiper-wrapper");
        $(".featured-slider .swiper-wrapper > div").addClass("swiper-slide");
        featuredSwiper = new Swiper(".featured-slider", {
          slidesPerView: 2.1,
          spaceBetween: 16,
          slidesOffsetBefore: 10,
          slidesOffsetAfter: 10,
          breakpoints: {
            1024: {
              slidesPerView: 3.1,
              spaceBetween: 16,
            },
          },
        });
      }
    };

    sliderBreakpoint.addListener(sliderBreakpointChecker);
    sliderBreakpointChecker();
  }

  MobileOnlySlider();

  // quick add modal functionality
  $(".quick-product-modal").on("click", function () {
    let main_modal_space = $(".load_content_quick_view");
    let product_handle = $(this).attr("data-product-handle");

    $.get("/products/" + product_handle + "?view=json", function (HTML_data) {
      main_modal_space.html(HTML_data);
    });

    return false;
  });

  $(".pins-list .pin").on("click", function () {
    let main_modal_space = $(".load_content_quick_view");
    let product_handle = $(this).attr("data-product-handle");

    $.get("/products/" + product_handle + "?view=json", function (HTML_data) {
      main_modal_space.html(HTML_data);
    });

    return false;
  });

  $(".load_content_quick_view .close").on("click", function () {
    $(".product-modal.modal-open").removeClass("modal-open").fadeOut();
    $(".load_content_quick_view").html("");
  });

  $(document).click(function (e) {
    if ($(e.target).is(".modal-window")) {
      $(".product-modal.modal-window").fadeOut(500);
      $(".load_content_quick_view").html("");
    }
  });

  //FILTERS-ACCORDION
  //open multiple accordions
  $(".filters-accordion-head").on("click", function () {
    $(this).siblings(".filters-accordion-content").slideToggle();
    $(this).toggleClass("active");
  });

  /// Mobile support pages navigation menu

  $(".support-mobile-navigation select").change(function () {
    var getValue = $(this).val();
    if (getValue === "faq") {
      document.location.href = "/pages/faq";
    } else if (getValue === "shipping") {
      document.location.href = "/pages/shipping-returns";
    } else if (getValue === "contact") {
      document.location.href = "/pages/contact";
    }
  });
})(jQuery);
